module.exports = __webpack_public_path__ + "media/images/favicon-32x32-bf54d43d18d2eafb7f39a149dc376b56.png";